/* istanbul ignore file */
import { useShowContext } from 'framework/show';
import { FullDateField } from 'framework/ui/field';
import ProcessStateBadge from 'domain/gpo/cockpit/instance/shared/ProcessStateBadge';
import ProcessStartInfoField from 'domain/gpo/cockpit/instance/shared/ProcessStartInfoField';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import ProcessInstanceEntityTitle from 'domain/gpo/cockpit/instance/shared/header/ProcessInstanceEntityTitle';
import ProcessInstanceIdField from 'domain/gpo/cockpit/instance/shared/header/ProcessInstanceIdField';
import ProcessInstanceLinkField from '../ProcessInstanceLinkField';
import { EntityHeader, HEADER_SIZES } from 'framework/ui/layout';
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { Typography } from '@mui/material';

const ProcessInstanceEntityHeader = () => {
  const { data } = useShowContext();
  const businessKey = data.getValueBySource('businessKey');
  const id = useProcessInstanceId();
  const endDateTime = data.getValueBySource('endDateTime');
  const state = data.getValueBySource('state');
  const parentProcessId = data.getValueBySource('parentProcessId');

  return (
    <EntityHeader
      entityTitle={<ProcessInstanceEntityTitle businessKey={businessKey} />}
      size={HEADER_SIZES.SMALL}
      badges={[<ProcessStateBadge state={state} />]}
      defaultAuthor={DEFAULT_ENTITY_AUTHOR}
    >
      <>
        <ProcessInstanceIdField value={id} />
        <ProcessStartInfoField processStarterSource="processStarter" startDateTimeSource="startDateTime" />
        {endDateTime && (
          <FullDateField
            label={
              <Typography component="span" fontStyle="italic">
                Ended
              </Typography>
            }
            value={endDateTime}
          />
        )}
        {parentProcessId && (
          <ProcessInstanceLinkField label={<span>Parent process</span>} source="parentProcessId" isInternal={false} />
        )}
      </>
    </EntityHeader>
  );
};

export default ProcessInstanceEntityHeader;
